import React, {SyntheticEvent, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Checkbox, Form, Input, InputGroup, Message, SelectPicker, Toggle, Uploader} from "rsuite";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";

import OrderProductsDelivery from "../OrderProductsDelivery/OrderProductsDelivery"
import GenericButton from "../../Buttons/GenericButton";
import DeliverySavedAddress from "../OrderProductsDelivery/delivery/DeliverySavedAddress/DeliverySavedAddress";
import DeliveryByTrackingCode from "../../DeliveryByTrackingCode/DeliveryByTrackingCode";

import deliveryAddressService from "../../../services/deliveryAddressService";
import ShippingAddress from "../../../interfaces/ShippingAddress";
import Pagination from "../../../interfaces/Pagination";

import SearchIcon from '@rsuite/icons/Search';

import {ItemDataType} from "rsuite/cjs/@types/common";
import PaymentAndPickupData from "../../../interfaces/PaymentAndPickupData";
import AddOrderModel from "../../../dto/order/AddOrderModel";
import {DeliveryType} from "../../../enums/DeliveryType";

import {CarrierType} from "../../../enums/CarrierType";
import {useAppSelector} from "../../../hooks";
import User from "../../../interfaces/User";

import AuthProvider from "../../../services/AuthProvider";
import {FileType} from "rsuite/Uploader";

import './OrderProductsShipping.sass'
import PaymentsList from "../../../interfaces/PaymentType";
import RadioGroupComponent from "../../RadioGroupComponent/RadioGroup";
import ShippingInvoiceUrlModel from "../../../dto/order/shipping/ShippingInvoiceUrlModel";


interface SelectItem{
    label: string,
    value: string
}

const Field = React.forwardRef((props: any, ref: any) => {
    const { name, message, label, accepter, error, defaultValue, ...rest } = props;
    return (
        <Form.Group controlId={`${name}-10`} ref={ref} className={error ? 'has-error' : ''}>
            <Form.ControlLabel>{label}</Form.ControlLabel>
            <Form.Control name={name} accepter={accepter} defaultValue={defaultValue} errorMessage={error} {...rest} />
            <Form.HelpText>{message}</Form.HelpText>
        </Form.Group>
    );
});

const OrderProductsShipping: React.FC<{order: AddOrderModel,
    onSavedAddressChange: (addressId: number, paymentType: number | null) => void,
    onNewAddressChange: Function,
    onPaymentPickupDataChange: (data: PaymentAndPickupData) => void,
    errorsStateShipping: boolean,
    errorsDeliveryByTrackingCode?: boolean,
    showPayOnDelivery: boolean,
    showDeliveryPayer: boolean,
    onUpdateDeliveryByTrackingCode?: ((state: string | null, cartOrderId: number, isDeliveryByTrackingCode: boolean) => void ) | null,
    updateOrderNpClientName: ((state: boolean, cartOrderId: number) => void ) | null,
    updatePaymentControl: ((state: boolean, cartOrderId: number) => void ) | null,
    paymentTypesList?: PaymentsList,
    setMinimumShippingProductCost?: (value: boolean) => void,
    handleWarehouse?: (id: number) => void, }> = (
    {order,
        onSavedAddressChange,
        onNewAddressChange,
        onPaymentPickupDataChange,
        errorsStateShipping,
        errorsDeliveryByTrackingCode,
        showPayOnDelivery,
        showDeliveryPayer,
        updateOrderNpClientName,
        updatePaymentControl,
        onUpdateDeliveryByTrackingCode,
        paymentTypesList,
        setMinimumShippingProductCost,
        handleWarehouse
    }) => {
    const {t} = useTranslation();
    const [tabIndex, setTabIndex] = useState(0);
    const addressShipping = t('order.addressShipping')
    const payer = t('delivery.payer')
    const sum = t('delivery.sum')

    const user = useAppSelector<User>(state => state.user.value)

    const [deliveryAddressList, setDeliveryAddressList] = useState<ShippingAddress[]>([])
    const [deliveryPayer] = useState([{label: t('deliveryPayer.sender'), value: 0}, {label: t('deliveryPayer.receiver'), value: 1}])
    const [chosenAddress, setChosenAddress] = useState<ShippingAddress | null>(null)
    const [toggleEditAddress, setToggleEditAddress] = useState(false)
    const [isPickup, setIsPickup] = useState<boolean>(order?.isPickup?? false)
    const [isFilePdf, setIsFilePdf] = useState(true);
    const [isFileSizeValid, setIsFileSizeValid] = useState(true);
    const [serverErrorMessage, setServerErrorMessage] = useState<string | null>(null);
    const lang = useAppSelector<string>(state => state.currentLang.value)

    const [searchTerm, setSearchTerm] = useState('')
    const searchShippingAddress = (value: string, event: any) => {
        if (value.length >= 2){
            setSearchTerm(value)
        } else {
            setSearchTerm('')
        }

    }

    let addressPagination: Pagination = {
        "totalPageCount": 1,
        "totalItemCount": 50,
        "currentPageNumber": 1,
        "pageSize": 10,
    }

    useEffect(() => {
        if (order.deliveryAddress) {
            setChosenAddress(order.deliveryAddress);
            setToggleEditAddress(true);
        }

    }, [])

    useEffect(() => {
        deliveryAddressService.getDeliveryAddresses(searchTerm, addressPagination.currentPageNumber, addressPagination.pageSize)
            .then(data => {
                setDeliveryAddressList(data.items)
            })

    }, [searchTerm])

    const [openListAddresses, setOpenListAddresses] = useState(false)

    const openAddresses = () => {
        setOpenListAddresses(true)
        //setOpenChosenAddress(false)
    }

    const [isShowPaymentTypes, setIsShowPaymentTypes] = useState(false);
    const [paymentPickupData, setPaymentPickupData] = useState<PaymentAndPickupData>({
        deliveryPayer: order.deliveryPayer,
        orderToPay: order.cashOnDeliveryAmount,
        carModel: order.carModel,
        carNumber: order.carNumber,
        pickupDate: order.pickupDate,
        pickupTime: order.pickupTime,
        paymentType: order.paymentType
    })

    const selectSavedAddress = (address: ShippingAddress) => {

        if (paymentTypesList && paymentPickupData.orderToPay && (address.carrierType === CarrierType.DPD || address.carrierType === CarrierType.Raben)){
            if(paymentTypesList[address.carrierType].length > 1) {
                setIsShowPaymentTypes(true);
            } else {
                setIsShowPaymentTypes(false);
            }
            setPaymentPickupData({...paymentPickupData, pickupTime: null, pickupDate: null, carNumber: null, carModel: null,
                paymentType: paymentTypesList[address.carrierType].find((paymentType) => paymentType.isDefault)?.id});
            //onPaymentPickupDataChange({...paymentPickupData, paymentType: paymentTypesList[address.carrierType].find((paymentType) => paymentType.isDefault)?.id})
            const ptype = paymentTypesList[address.carrierType].find((paymentType) => paymentType.isDefault)?.id;
            if(ptype) {
                onSavedAddressChange(address.id!, ptype);
            }
        }
        else {
            setIsShowPaymentTypes(false);
            setPaymentPickupData({...paymentPickupData, pickupTime: null, pickupDate: null, carNumber: null, carModel: null, paymentType: null});
            onSavedAddressChange(address.id!, null);
        }

        setChosenAddress(address)

        setOpenListAddresses(false)
        setToggleEditAddress(true)
        setIsPickup(false)
    }

    const isEditAddress = () => {
        setToggleEditAddress(current => !current)
    }

    const saveNewAddress = (data: ShippingAddress) => {
        setChosenAddress(data)
        setPaymentPickupData({...paymentPickupData, pickupTime: null, pickupDate: null, carNumber: null, carModel: null})
        onNewAddressChange(data)
        setToggleEditAddress(true)
        setIsPickup(false)
        if (paymentTypesList && paymentPickupData.orderToPay && (data.carrierType === CarrierType.DPD || data.carrierType === CarrierType.Raben)){
            if(paymentTypesList[data.carrierType].length > 1) {
                setIsShowPaymentTypes(true);
            } else {
                setIsShowPaymentTypes(false);
            }
        }
    }



    const deliveryPayerChange = (value: string | null, item: ItemDataType, event: SyntheticEvent<Element, Event>) => {
        setPaymentPickupData({...paymentPickupData, deliveryPayer: +value!})
        if(onPaymentPickupDataChange) {
            onPaymentPickupDataChange({...paymentPickupData, deliveryPayer: +value!})
        }
    }

    const setOrderAmount = (value: string , event: any) => {
        value = event.target.value.replace(/[^0-9]/g, "")

        if(+value == 0) {
            setIsPaymentControl(false);
        }

        let newData = {};
        if (paymentTypesList && +value > 0 && (chosenAddress?.carrierType === CarrierType.DPD || chosenAddress?.carrierType === CarrierType.Raben)) {
            if(paymentTypesList[chosenAddress?.carrierType].length > 1) {
                setIsShowPaymentTypes(true);
            } else {
                setIsShowPaymentTypes(false);
            }
            newData = {
                ...paymentPickupData,
                paymentType: paymentTypesList[chosenAddress.carrierType].find((paymentType) => paymentType.isDefault)?.id,
                orderToPay: +value!
            };
            setPaymentPickupData(newData);
        } else {
            setIsShowPaymentTypes(false);
            newData = {...paymentPickupData, orderToPay: +value!};
            setPaymentPickupData(newData);
        }

        if(onPaymentPickupDataChange) onPaymentPickupDataChange(newData);
    }

    const updatePaymentPickupData = (data: PaymentAndPickupData) => {
        if (paymentTypesList && data.orderToPay &&
            (chosenAddress?.carrierType === CarrierType.DPD || chosenAddress?.carrierType === CarrierType.Raben) &&
            paymentTypesList[chosenAddress?.carrierType].length > 1 ) {
            setIsShowPaymentTypes(true);
        } else {
            setIsShowPaymentTypes(false);
        }
        setPaymentPickupData(data)
        if (data.pickupDate != null || data.pickupTime != null
        || data.carModel != null || data.carNumber != null) {
            setChosenAddress(null)
            onNewAddressChange(null)
            setToggleEditAddress(true)
            setIsPickup(true)
        }
        if(onPaymentPickupDataChange) {
            onPaymentPickupDataChange(data)
        }
    }

    const focusInput = (el: any) => {

        const inputs = document.getElementsByClassName('rs-picker-search-bar-input')
        for (let i = 0; i < inputs.length; i++) {
            const slide = inputs[i] as HTMLElement;
            slide.focus();
        }
    }



    useEffect(() => {

        if (updateOrderNpClientName && chosenAddress?.carrierType == CarrierType.NewPost) {
            updateOrderNpClientName(user.useNPNameByDefault,  order.tempId)
        } else if (updateOrderNpClientName) {
            updateOrderNpClientName(false,  order.tempId)
        }
    }, [chosenAddress?.carrierType])


    const [isChangeBuDefault, setIsChangeBuDefault] = useState(user.useNPNameByDefault)

    /*useEffect(() => {
        if (updateOrderNpClientName) {
            updateOrderNpClientName(user.useNPNameByDefault, order.tempId)
        }
    }, [])*/

    const changeUseNameByDefault = (checked: boolean, event: any) => {

        setIsChangeBuDefault(checked)

        if (updateOrderNpClientName) {
            updateOrderNpClientName(checked, order.tempId)
        }

        if (!checked) {
            setIsPaymentControl(false)

        }
    }

    const [isPaymentControl, setIsPaymentControl] = useState(order.usePaymentControl)

    const changePaymentControl = (checked: boolean, event: any) => {

        setIsPaymentControl(checked)

        if (updatePaymentControl) {
            updatePaymentControl(checked, order.tempId)
        }
    }

    const [isSendByTrackingCode, setIsSendByTrackingCode] = useState(false);
    const [isDisableUpload, setIsDisableUpload] = useState(false);
    const [deliveryTrackingFileUrl, setDeliveryTrackingFileUrl] = useState('');
    const onUpload = (response: object, file: FileType,) => {
        //setErrorsDeliveryByTrackingCode(true);
        setIsDisableUpload(true);
        setServerErrorMessage(null);
        if (onUpdateDeliveryByTrackingCode && 'data' in response) {
            const data = response.data as ShippingInvoiceUrlModel;
            setDeliveryTrackingFileUrl(data.url);
            onUpdateDeliveryByTrackingCode(data.url, order.tempId, isSendByTrackingCode)
        }
    }

    const onRemoveFile = (file: FileType) => {
        //setErrorsDeliveryByTrackingCode(false)
        setDeliveryTrackingFileUrl('')
    }

    useEffect(() => {
        if (onUpdateDeliveryByTrackingCode) {
            onUpdateDeliveryByTrackingCode(null, order.tempId, isSendByTrackingCode);
        }
    }, [isSendByTrackingCode]);

    const handleFileUpload = (file: FileType) => {
        const rawFile = file.blobFile as File;
        const isPdf = rawFile.type === 'application/pdf';
        const isLt5M = rawFile.size / 1024 / 1024 < 5;

        if (!isPdf) {
            setIsFilePdf(false);
            return false;
        } else {
            setIsFilePdf(true)
        }

        if (!isLt5M) {
            setIsFileSizeValid(false);
            return false;
        } else {
            setIsFileSizeValid(true)
        }

        return true;
    }
    const changePaymentMethod = (value: number) => {
        if (value) {
            onPaymentPickupDataChange({...paymentPickupData, paymentType: +value!})
        }
    }

    const handleMinEstimatedValue = (value: boolean) => {
        if (setMinimumShippingProductCost) {
            setMinimumShippingProductCost(value);
        }
    }


    return(
        <div className="shipping_wrapper-body">
            <div className="shipping-header-wrapper">
                <h3>{t('order.shipping')}</h3>

                {toggleEditAddress ? <GenericButton
                        generic={"edit"}
                        onClick={isEditAddress}
                        isDisabled={false}
                        showText={true}
                    />
                  : null}
            </div>
            {process.env.REACT_APP_LOCATION == 'pl' && <>
                {errorsDeliveryByTrackingCode ? null : <Message className="error-sm" showIcon type="error">
                    <p>{t('order.errorDeliveryByTrackingCode')}</p>
                </Message>}

                <DeliveryByTrackingCode onDeliveryByTracking={setIsSendByTrackingCode} />

                {!isFilePdf && <Message className="error-sm" showIcon type="error">
                    <p>{t('order.errorOnlyPdf')}</p>
                </Message>}
                {!isFileSizeValid && <Message className="error-sm" showIcon type="error">
                    <p>{t('order.errorFileSize')}</p>
                </Message>}
                {serverErrorMessage != null && <Message className="error-sm" showIcon type="error">
			            <p>{serverErrorMessage}</p>
		            </Message>}

                {isSendByTrackingCode && <div className="uploader-fake-wrapper mb-15">
                        <Uploader
                            accept=".pdf"
                            headers={{authorization: 'bearer ' + AuthProvider.getAuthToken(), "accept-language": lang}}
                            listType="picture-text"
                            action={process.env.REACT_APP_API_URL! + 'orders/shipping-invoice'}
                            onSuccess={	(response: object, file: FileType) => onUpload(response, file)}
                            onError={(err) => setServerErrorMessage(err.response.message)}
                            disabled={isDisableUpload}
                            onRemove={onRemoveFile}
                            multiple={false}
                            shouldUpload={(file: FileType) => handleFileUpload(file)}
                        >
                            <div style={{ height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, textAlign: "center" }}>
                                <span>{t('uploadExel.dragDrop')}</span>
                            </div>
                        </Uploader>
                    </div>
                }
            </>
            }
                    {errorsStateShipping ? null : <Message className="error-sm" showIcon type="error">
                        <p>{t('order.errorAddressShipping')}</p>
                    </Message>}
                    {!toggleEditAddress ?
                        <Tabs className="delivery-tabs" selectedIndex={tabIndex} onSelect={setTabIndex}>
                            <TabList>
                                <Tab>{t('delivery.savedAddress')}</Tab>
                                <Tab>{t('delivery.newDelivery')}</Tab>
                            </TabList>

                            <TabPanel>
                                <div className="search-shipping-wrapper">
                                    <InputGroup inside>
                                        <Input placeholder={addressShipping} onChange={searchShippingAddress} onFocus={openAddresses} />
                                        <InputGroup.Button>
                                            <SearchIcon  color="#0090D4" />
                                        </InputGroup.Button>
                                    </InputGroup>
                                    {openListAddresses ? <div className="choose-recipient_list">
                                        {deliveryAddressList.map((address, index) => {
                                            return (
                                                <button key={index} className="choose-address-shipping" onClick={() => selectSavedAddress(address)}>

                                        <span>
                                            {address.deliveryType == DeliveryType.CourierDelivery ? t('delivery.stockDelivery') : null}
                                            {address.deliveryType == DeliveryType.BranchDelivery ? t('delivery.addressDelivery') : null},&nbsp;
                                        </span>
                                                    <span>{address?.carrierType == CarrierType.NewPost ? t('carrierType.NewPost') : null}
                                                        {address?.carrierType == CarrierType.MeestExpress ? t('carrierType.MeestExpress') : null}
                                                        {address?.carrierType == CarrierType.Delivery ? t('carrierType.Delivery') : null}
                                                        {address?.carrierType == CarrierType.AddressDelivery ? t('carrierType.UkrPost') : null}, &nbsp;</span>
                                                    <span>{address.city}, &nbsp;</span>
                                                    {address.postalCode ? <span>{address.postalCode} &nbsp;</span> : null}
                                                    <span>{address.state}, &nbsp;</span>
                                                    {address.carrierBranch ? <span>{address.carrierBranch}, &nbsp;</span> : null}
                                                    {address.street ? <span>{address.street} &nbsp;</span> : null}
                                                    {address.house ? <span>{address.house} &nbsp;</span> : null}
                                                    {address.apartment ? <span>{address.apartment}</span> : null}

                                                </button>
                                            )
                                        })}
                                    </div> : null}

                    </div>
                </TabPanel>
                <TabPanel>
                    <OrderProductsDelivery
                        onChange={saveNewAddress}
                        onPaymentPickupDataChange={updatePaymentPickupData}
                        showPayOnDelivery={showPayOnDelivery}
                        paymentTypesList={paymentTypesList}
                        weight={order.weight}
                        handleWarehouse={handleWarehouse}
                    />
                </TabPanel>
            </Tabs>
                : null}

            {toggleEditAddress && <div>
                    <DeliverySavedAddress savedAddress={chosenAddress} paymentPickupData={paymentPickupData} labels={false} />

                    {/* TODO: Temporarily disabled. Restore this checkbox when the "Use minimum shipping product cost"*/}
                    {/*{(chosenAddress?.carrierType == CarrierType.NewPost) &&  <div className="mb-15">
                        <Checkbox
                            inline
                            onChange={(value, checked) => handleMinEstimatedValue(checked)}
                        >
                            <p style={{marginTop: "2px"}}>{t('order.useMinimumShippingProductCost')}</p>
                        </Checkbox>
                    </div>}*/}

                    {(chosenAddress?.carrierType == CarrierType.NewPost && user.npClientName !== null) &&  <div className="dropship-wrapper">
                        <strong>{t('profile.npClientName')}:</strong>
                        <div className="mt-15">
                            <Toggle checked={isChangeBuDefault} onChange={changeUseNameByDefault} className="comparison-difference" /> {user.npClientName}
                        </div>
                    </div>}

                </div>}

            {(toggleEditAddress && !isPickup) || tabIndex == 0 ?
            <div className="payment-info-wrapper">
                <h3>{t('order.shippingPayment')}</h3>
                <Form>
                    {showDeliveryPayer ? <div className="input-wrapper selectpicker input-payer">
                        <Field
                            name="payer"
                            label={payer}
                            accepter={SelectPicker}
                            value={paymentPickupData.deliveryPayer ?? 1}
                            searchable={false}
                            data={deliveryPayer}
                            onSelect={deliveryPayerChange}
                            onOpen={focusInput}
                        />
                    </div> : null }

                    {showPayOnDelivery ? <div className="input-wrapper input-sum">
                        <Field
                            name="sum"
                            label={sum}
                            value={paymentPickupData.orderToPay}
                            accepter={Input}
                            min={1}
                            onChange={setOrderAmount}
                        />
                    </div> : null}

                    {isShowPaymentTypes && chosenAddress && paymentTypesList ? <>
                        <RadioGroupComponent
                        paymentTypes={paymentTypesList[chosenAddress.carrierType]}
                        onChangePaymentMethod={changePaymentMethod}
                        value={paymentPickupData.paymentType}/>
                        </> :null}
                    {chosenAddress?.carrierType === CarrierType.Raben ? <div className="pay-method-info"><p>{t('order.paymentRabenMsg')}</p></div> : null}
                    {chosenAddress?.carrierType === CarrierType.DPD ? <div className="pay-method-info"><p>{t('order.paymentDpdMsg')}</p></div> : null}

                </Form>

                {paymentPickupData.orderToPay &&
                user.isPaymentControlEnabled &&
                isChangeBuDefault &&
                chosenAddress?.carrierType === CarrierType.NewPost ? <div>
                    <p className='mt-15'><strong>Контроль оплаты</strong> </p>
                    <div className="mt-15">
                        <Toggle checked={isPaymentControl} onChange={changePaymentControl} className="comparison-difference" />
                    </div>
                </div> : null}

                {showPayOnDelivery &&
                !isShowPaymentTypes &&
                process.env.REACT_APP_LOCATION == 'ua'
                    ? <div className="pay-method-info">
                    <p>{t('order.payMethod')}</p>
                </div> : null}

            </div>: null}

        </div>
    )
}
export default OrderProductsShipping